import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';
import { useCallback, useMemo } from 'react';

import { ButtonDecorator } from '../../components/ButtonDecorator/ButtonDecorator';
import { Bem } from '../../service/Bem/Bem';
import { CommonCreativeRenderer } from '../CommonCreativeRenderer/CommonCreativeRenderer';
import { PresetData, PresetsProps } from '../Presets/typings';

import './CommonPresets.css';
import * as keyset from './CommonPresets.i18n';

const i18n = i18nFactory(keyset);
const BLOCK = 'common-presets';

type CommonPresetsProps = Pick<PresetsProps, 'dataProvider' | 'selectPreset'>;

export class CommonPresets extends React.PureComponent<CommonPresetsProps> {
    static PresetItem = React.memo(
        ({ item, click }: { item: PresetData; click: (id: string, isAdaptive?: boolean) => void }) => {
            const onClick = useCallback(() => click(item.id, item.isAdaptive), [item.id]);
            const rendererData = useMemo(() => ({ alt: item.alt, thumbnail: item.thumbnail }), [
                item.alt,
                item.thumbnail
            ]);
            const controls = useMemo(
                () => <ButtonDecorator theme="normal" size="n" text={i18n('create')} onClick={onClick} />,
                [onClick]
            );

            return (
                <CommonCreativeRenderer item={rendererData} controls={controls}>
                    {item.isAdaptive && <div className={Bem.cls(BLOCK, 'description')}>{i18n('adaptive')}</div>}
                </CommonCreativeRenderer>
            );
        }
    );

    render(): React.ReactNode {
        const { dataProvider, selectPreset } = this.props;

        return (
            <div className={BLOCK}>
                {dataProvider.map(item => (
                    <div key={item.id} className={Bem.cls(BLOCK, 'item')}>
                        <CommonPresets.PresetItem item={item} click={selectPreset} />
                    </div>
                ))}
            </div>
        );
    }
}
